module.exports = __webpack_public_path__ + "static/img/v3.10fdf1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/v3.png
// module id = f6KJ
// module chunks = 1